import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Kiitos, {{name}}',
    confirmation_email:
      'Saat pian vahvistussähköpostin tilausnumerollasi sähköpostiosoitteeseesi teknologiakumppaniltamme {{provider_email}}',
    need_help: 'Tarvitsetko apua?',
  },
  labels: {
    order_number: 'Tilausnro: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Tänään',
    was_prefix: 'oli',
    restaurant: 'Ravintola',
    order_details: 'Tilauksen tiedot',
    your_details: 'Omat tietosi',
    contact: 'Yhteystiedot',
    payment: 'Maksu',
    payment_method: 'Maksutapa',
    delivery: 'Toimitus',
    delivery_details: 'Toimitustiedot',
    pickup_details: 'Noutotiedot',
    pickup_instruction: '📋 Kerro tilausnumerosi {{number}} noutaessasi tilauksen.',
    billing_info: 'Laskutustiedot',
    order_note: 'Tilauksen huomautus',
    order_summary: 'Tilauksen yhteenveto',
    help: 'Tarvitsetko apua? Ota yhteyttä {{phone_number}}',
  },
  status: {
    canceled: 'Tilaus peruutettu',
    received: 'Tilaus vastaanotettu',
    confirmed: 'Tilaus vahvistettu!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Nouto',
    [ORDER_METHODS.DELIVERY]: 'Toimitus',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Huonepalvelu',
      [RoomServiceLocationType.TableService]: 'Pöytäpalvelu',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(huone #{{details}})',
    [RoomServiceLocationType.TableService]: '(pöytä #{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Ansaitut pisteet',
      from_order: 'pistettä tästä tilauksesta',
      total_balance: 'Kokonaissaldo',
      reward_value: 'Palkinnon arvo',
      redeem_hint: '✓ Voit lunastaa jopa {{points}} pistettä ({{amount}}) seuraavassa tilauksessasi',
      points_to_redeem: 'Tarvitset vielä {{points}} pistettä lunastaaksesi palkintosi',
    },
    guest: {
      pill_title: 'Palkinnot',
      earned_heading: 'Ansaitsit <highlight>{{points}} pistettä</highlight> tästä tilauksesta',
      worth_on_next: 'Arvoltaan <strong>{{amount}}</strong> seuraavassa tilauksessasi',
      ready_to_claim: 'Valmis lunastettavaksi',
      next_order_discount: 'Alennus seuraavaan tilaukseen',
      claim_cta: 'Lunasta {{points}} pistettäsi — rekisteröidy ilmaiseksi',
      claim_note: 'Vie 30 sekuntia · pisteet hyvitetään heti',
    },
  },
  buttons: {
    back_to_menu: 'Takaisin ruokalistaan',
    back_to_checkout: 'Takaisin kassalle',
    contact_us: 'Ota yhteyttä {{phone_number}}',
    try_again: 'Yritä uudelleen',
  },
  loading: {
    processing_payment: 'Älä poistu sivulta, kun käsittelemme maksuasi',
  },
  success_messages: {
    order_placed: {
      title: '✅ Tilaus onnistui!',
      description: 'Tilauksesi on tehty onnistuneesti.',
    },
  },
  error_messages: {
    failed_to_load: 'Tilausta ei voitu ladata. Yritä uudelleen.',
    payment_failed: 'Maksu epäonnistui, yritä uudelleen',
  },
  load_failed: {
    title: 'Tilaustasi ei voitu ladata',
    description:
      'Tilauksesi tietojen lataamisessa tapahtui virhe. Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä tukeen, niin autamme sinua heti.',
  },
};
